import React from "react";
import './TextArea.scss'



const TextArea = ({className, type="text",titulo = "title", obligatorio = true, placeholder, id, onChange,value,disabled }) => {
    return (
        <div className="TextArea">
            <div className="contenedorTitulo">
                {
                    obligatorio ?
                    <>
                            <div className="obligatorio">*</div>
                        </>:null
                }
                <div className="titulo">{titulo}</div>
            </div>
            <textarea className={`${className}`} type={type} disabled={disabled} value={value} id={id} onChange={onChange} placeholder={placeholder} />
        </div>
    )
}
export default TextArea